import { ChangeDetectionStrategy, Component } from '@angular/core';
import { QuickOrderTableComponent } from '@spartacus/cart/quick-order/components';

@Component({
    selector: 'gen-quick-order-table',
    templateUrl: './quick-order-table.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class GenQuickOrderTableComponent extends QuickOrderTableComponent {}
